import React from "react";
import {
  IllustrationColumn,
  AuthFormContainer,
  Heading,
  Description,
  Container,
  UsersList,
  EachUser,
  MobileHeader,
  CenteringWrapper,
  ParentContainer,
} from "./styles";
import images from "../../Constant/images";
import { FONTS, STYLES } from "../../Constant/Theme";
import Colors from "../../Constant/Colors";
import SmartImage from "../../Components/SmartImage";
import CustomText from "../../Components/Text";

const AuthLayout = ({
  children,
  title = "",
  description = "",
  handleUser,
  userType,
  isLogin,
}) => {
  let screenWidth = window.innerWidth;

  return (
    <Container>
      <IllustrationColumn>
        <div
          style={{ ...STYLES.HorizontalAlign, width: "100%", marginTop: 10 }}
        >
          <SmartImage
            src={images.logo}
            alt="homepage"
            style={{ width: 80, height: 80, marginRight: 10 }}
          />
          <CustomText
            style={{ ...FONTS.Bold20, color: Colors.whiteThemeColor }}
            text={"Power Education"}
          />
        </div>
        <SmartImage
          src={images.login}
          alt="homepage"
          style={{
            width: "100%",
            height: "60%",
            marginTop: 80,
          }}
        />
        <div style={{ display: "flex", flexDirection: "column", padding: 40 }}>
          <CustomText
            style={{ ...FONTS.SemiBold20, color: Colors.whiteThemeColor }}
            text={"E - Learning For All"}
          />
          <CustomText
            text={"Everything you need in an School"}
            style={{
              ...FONTS.Regular10,
              color: Colors.lightGreen,
            }}
          />
        </div>
      </IllustrationColumn>

      <MobileHeader>
        <SmartImage
          src={images.logo}
          alt="homepage"
          style={{
            width: "10%",
            height: "20%",
            marginRight: 20,
          }}
        />
        <CustomText
          style={{ ...FONTS.SemiBold24, color: Colors.whiteThemeColor }}
          text={"Power Education"}
        />
      </MobileHeader>
      <ParentContainer>
        <AuthFormContainer>
          <UsersList>
            {!isLogin &&
              userType.map((each) => (
                <EachUser
                  key={each.id}
                  isSelected={each?.isSelected}
                  onClick={() => handleUser(each)}
                >
                  <SmartImage
                    src={each.icon}
                    alt={each.user}
                    style={{ height: 25, width: 25, marginRight: 10 }}
                  />
                  <CustomText
                    text={each.user}
                    style={{
                      ...(each?.isSelected ? FONTS.Bold14 : FONTS.Medium13),
                      color: Colors.primary,
                    }}
                  />
                </EachUser>
              ))}
          </UsersList>
          <div style={{ ...STYLES.VerticalAlign, width: "100%" }}>
            <Heading>{title}</Heading>
            <Description>{description}</Description>
            <div style={{ ...STYLES.VerticalAlign, width: "100%" }}>
              {children}
            </div>
          </div>
        </AuthFormContainer>
      </ParentContainer>
    </Container>
  );
};

export default AuthLayout;
